<template>
    <header id="header" class="fixed-top header-transparent">
        <div class="container-fluid">
            <button type="button"
                    @click="showMobile()"
                    class="mobile-nav-toggle d-lg-none">
                <i class="icofont-navigation-menu"></i>
            </button>
            <div class="row justify-content-center">
                <div class="col-xl-11 d-flex align-items-center">
                    <!--<h1 class="logo mr-auto">
                        <a href="index.html">PharmaPLUS</a>
                        <div>
                            Le Logiciel pour offecines
                        </div>
                    </h1>-->
                    <!-- Uncomment below if you prefer to use an image logo -->
                    <a href="javascript:void(0)"
                       @click="goTo"
                       class="logo mr-auto">
                        <img :src="logo" alt="" class="img-fluid">
                    </a>
                    <nav class="nav-menu d-none d-lg-block">
                        <nav-component/>
                    </nav><!-- .nav-menu -->
                </div>
            </div>
            <nav-mobile v-if="show"/>
        </div>
    </header><!-- End Header -->
</template>

<script>
    import NavMobile from "./NavMobile";
    import NavComponent from "./NavComponent";
    import {mapMutations,mapState} from 'vuex'

    export default {
        name: "HeaderOne",
        components: {NavComponent, NavMobile},
        data(){
            return {
                logo: '../../../../images/icon/pharma.png'
            }
        },
        computed:{
          ...mapState({
              show: (state) => state.other.show
          })
        },
        methods:{
            ...mapMutations('other',['setShow']),
            showMobile(){
                this.setShow(!this.show)
            },
            goTo(){
                this.$router.push({path: '/pharmaplus/contact'})
            }
        },
        watch:{
            show(value){
                const el = document.body;
                if(document.body.classList.contains('mobile-nav-active')){
                    el.classList.remove('mobile-nav-active');
                }else {
                    el.classList.add('mobile-nav-active');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logo {
        position: relative;
        div{
            font-size: 9px;
            margin-left: 5px;
            color: #44D36F;
        }
    }
</style>